import { TableType, TitledTable } from '../../../../../components'
import {
  createMembershipArray,
  MaybeMembershipInfo,
  membershipKeysAndColumns
} from '../helpers/helper'

interface MembershipsProps {
  membershipInfo: MaybeMembershipInfo
}

export const Memberships = ({ membershipInfo }: MembershipsProps) => {
  const parsedData = createMembershipArray(membershipInfo)

  return (
    <TitledTable
      translationid="pages.ownInfoPage.membership.memberships.label"
      tableProps={{
        cellProps: membershipKeysAndColumns,
        data: parsedData,
        type: TableType.Static
      }}
    />
  )
}
